import ModalContentProvider from './hooks/useModalContent';

import { ModalContentProps } from './@types/ModalContentProps';

const ModalContent = (props: ModalContentProps) => <ModalContentProvider {...props}></ModalContentProvider>;

export default ModalContent;
